/** Small visual preview of a clinician's stored signature PNG.
 *
 *  Renders the base64 PNG inline as a data URL -- the bytes are
 *  already in the ``ClinicianSignatureT`` payload, so the preview is
 *  instant once the signature query resolves.
 */

import type { ClinicianSignatureT } from '../model/signatureTypes';

interface SignaturePreviewImageProps {
  signature: ClinicianSignatureT;
  /** When true, render at a smaller size so the preview fits inside
   *  narrow inline surfaces (e.g. the in-chat ``SignAndAttachChatCard``)
   *  without descenders or wide cursive letters getting clipped. */
  compact?: boolean;
  className?: string;
}

export function SignaturePreviewImage({
  signature,
  compact = false,
  className,
}: SignaturePreviewImageProps) {
  const maxHeight = compact ? '3.25rem' : '6rem';
  const src = `data:image/png;base64,${signature.png_base64}`;
  return (
    <img
      src={src}
      alt="Signature"
      className={className}
      style={{ maxHeight, maxWidth: '100%', objectFit: 'contain' }}
    />
  );
}
